let isMobile = ua => {
  return ua.match(/Mobile.*/)
}
export default isMobile